import React from 'react';
import { formatPhoneNumber } from 'react-phone-number-input';

import FormTitle from 'components/PageLayout/FormTitle';
import AuthCodeInput from 'components/curo-components/common/AuthCodeInput';
import { getSignInProcessState } from 'handlers/curo-handlers/selectors';
import { useAppSelector } from 'hooks/reduxHooks';
import useDispatchWithUnwrap from 'hooks/useDispatchWithUnwrap';
import CuroMainLayout from 'layout/CuroMainLayout';
import { sendVerificationCode, verifyCode } from 'thunks';

import styles from './SIgnInProcessStep.module.scss';

const PAGE_TITLE = 'Sign In';

interface IVerifyCodeStepProps {
  onStepComplete: () => void;
}

const VerifyCodeStep = ({ onStepComplete }: IVerifyCodeStepProps) => {
  const { phone } = useAppSelector(getSignInProcessState);
  const dispatchWithUnwrap = useDispatchWithUnwrap();

  const formattedPhoneNumber = formatPhoneNumber(phone);

  const handleVerifyCode = async (code: string) => {
    await dispatchWithUnwrap(verifyCode(code));
    onStepComplete();
  };

  const handleResendCode = async () => {
    await dispatchWithUnwrap(sendVerificationCode(phone));
  };

  return (
    <CuroMainLayout>
      <FormTitle
        title={PAGE_TITLE}
        subTitle={
          <p className={styles.pageDescription}>
            <span>
              We've sent a 6-digit verification code to <strong>{formattedPhoneNumber}</strong>.
            </span>
            <span>
              Once you receive the verification code, enter it here to confirm your identity.
            </span>
          </p>
        }
      />
      <AuthCodeInput
        handleResendCode={handleResendCode}
        handleVerifyCode={handleVerifyCode}
        buttonTitle="Sign In"
      />
    </CuroMainLayout>
  );
};

export default VerifyCodeStep;
